import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import styles from './ButtonBraun.module.css';

const ButtonBraun = ({
  onClickEvent,
  text,
  theme,
  url,
  customStyles,
  children,
}) => {
  return (
    <>
      <button
        type="button"
        onClick={onClickEvent}
        className={classnames(styles.buttonBraun, styles[theme], customStyles)}
      >
        {url ? (
          <Link to={url} className={styles.link}>
            {text}
          </Link>
        ) : (
          text
        )}
        {children}
      </button>
    </>
  );
};

ButtonBraun.defaultProps = {
  theme: 'light',
  customStyles: '',
  children: '',
  url: '',
};

ButtonBraun.propTypes = {
  text: PropTypes.string.isRequired,
  onClickEvent: PropTypes.func.isRequired,
  theme: PropTypes.string,
  customStyles: PropTypes.string,
  url: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element,
  ]),
};

export default ButtonBraun;
